<template>
  <!-- 对齐 EB layout/main/classic.vue：根容器纵向 flex-center -->
  <el-container class="layout-container flex-center layout-classic-root">
    <layout-header />
    <el-container class="layout-mian-height-50">
      <layout-aside />
      <div class="flex-center layout-backtop layout-classic-main">
        <tags-view v-if="showTagsInMain" :class="themeStore.themeConfig.tagsStyle" />
        <layout-main />
      </div>
    </el-container>
    <el-backtop target=".layout-backtop .el-scrollbar__wrap" />
  </el-container>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import useCrmebThemeConfigStore from '@/store/modules/themeConfig';
import TagsView from '@/layout/navBars/tagsView/index.vue';
import LayoutAside from '../component/Aside.vue';
import LayoutHeader from '../component/Header.vue';
import LayoutMain from '../component/Main.vue';

const themeStore = useCrmebThemeConfigStore();
const showTagsInMain = computed(() => themeStore.themeConfig.isTagsview);
</script>
